import { useEffect, useState } from "react";

export default function SuccessPage() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const email = params.get("email");

  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [autoStarted, setAutoStarted] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");

  const downloadUrl = `http://localhost:5000/api/download/${token}`;

  useEffect(() => {
    if (sessionStorage.getItem("autoDownloadDone")) {
      setAutoStarted(true);
      return;
    }

    if (countdown === 0) {
      sessionStorage.setItem("autoDownloadDone", "true");
      setAutoStarted(true);
      startDownload();
      return;
    }

    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown]);

  const startDownload = async () => {
    try {
      setDownloading(true);
      setProgress(0);

      const response = await fetch(downloadUrl);
      if (!response.ok) throw new Error("Download failed");

      const contentLength = response.headers.get("Content-Length");
      const total = contentLength ? parseInt(contentLength, 10) : null;

      const reader = response.body.getReader();
      let received = 0;
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        received += value.length;

        if (total) {
          setProgress(Math.round((received / total) * 100));
        }
      }

      const blob = new Blob(chunks, { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "The-Boring-Wealth.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
      setDownloading(false);
      setProgress(100);

    } catch (err) {
      console.error("Download error:", err);
      setError(
        "Automatic download failed. Please use the manual download button below."
      );
      setDownloading(false);
    }
  };

  const handleManualDownload = async () => {
    try {
      const response = await fetch(downloadUrl);

      if (!response.ok) {
        setShowExpiredModal(true);
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "The-Boring-Wealth.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch {
      setShowExpiredModal(true);
    }
  };

  return (
    <div className="container text-center section">

      <h1 className="gold-text mb-3">Payment Successful</h1>

      <p className="fs-5">
        Thank you for purchasing <strong>The Boring Wealth</strong>
      </p>

      <p className="text">
        Your personal copy has been sent to:
        <br />
        <strong>{email}</strong>
      </p>

      {!autoStarted && (
        <p className="mt-4 fs-6">
          Your download will start automatically in{" "}
          <strong className="gold-text">{countdown}</strong> seconds…
        </p>
      )}

      {downloading && (
        <div className="mt-4">
          <div className="spinner-border text-warning mb-3"></div>
          <p>
            Downloading…{" "}
            {progress ? <strong>{progress}%</strong> : "Please wait"}
          </p>

          {progress > 0 && (
            <div className="progress mx-auto" style={{ maxWidth: "320px" }}>
              <div
                className="progress-bar bg-warning"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          )}
        </div>
      )}

      {!downloading && autoStarted && !error && (
        <p className="mt-4 text-success">
          Download completed successfully.
        </p>
      )}

      {error && <p className="mt-4 text-danger">{error}</p>}

      <div className="my-4">
        <button
          className="btn btn-gold btn-lg px-5"
          onClick={handleManualDownload}
        >
          Download Now
        </button>
      </div>

      <p className="small text">
        If the download doesn’t start automatically, click the button above.
      </p>

      <hr className="my-4" />

      <p className="fst-italic text">
        Wealth is built by surviving longer.
      </p>

      {/* EXPIRED MODAL — MUST BE INSIDE RETURN */}
      {showExpiredModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bg-dark text-light border border-warning">

                <div className="modal-header border-warning">
                  <h5 className="modal-title text-warning">
                    Download Link Expired
                  </h5>
                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setShowExpiredModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <p>
                    Your download link has expired or the maximum number of
                    downloads has been reached.
                  </p>
                  <p className="small text-muted">
                    Please contact support with your order details.
                  </p>
                </div>

                <div className="modal-footer border-warning">
                  <button
                    className="btn btn-outline-warning"
                    onClick={() => setShowExpiredModal(false)}
                  >
                    Close
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

    </div>
  );
}
